export default __webpack_public_path__ + "static/media/Ellipse.dbbd2cd1.svg";